
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.216.625L16.33 1.67a1.26 1.26 0 011.029 1.282 27.318 27.318 0 01-2.546 10.173l2.152 3.288a.614.614 0 01-.196.863.677.677 0 01-.107.054l-3.758 1.952c-.426.166-.91.099-1.271-.177l-3.274-3.477v-7.5C12.216 6.247 12.216.625 12.216.625z"}}),_c('path',{attrs:{"d":"M10.609 10.625c0-.173.144-.313.32-.313.178 0 .322.14.322.313a.317.317 0 01-.321.312.317.317 0 01-.321-.312m0 3.122c0-.173.144-.313.32-.313.178 0 .322.14.322.313a.317.317 0 01-.321.312.317.317 0 01-.321-.312M9.001 7.755C5.787 5.605 5.787.625 5.787.625L1.673 1.67A1.257 1.257 0 00.644 2.952 27.302 27.302 0 003.19 13.125l-2.152 3.288a.613.613 0 00.194.862c.035.023.071.04.11.055l3.757 1.952c.426.166.91.098 1.27-.177l2.632-2.797M5.787.625h6.429"}})])])
          )
        }
      }
    